module.exports = __webpack_public_path__ + "sflyssofe.6cd46a7332.svg";